(function () {


	angular.module('app.widgets')
	.directive('plaNavBar', plaNavBar);

	plaNavBar.$inject = ['UserInfoService', '$location'];

	function plaNavBar(UserInfoService, $location) {
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            templateUrl: 'app/widgets/navbar.html',
            link: function(scope, element, attrs) {
				jQuery(window).resize();
				_topNav();
				userInfoChanged(scope, UserInfoService, $location);
              }
        }
    }

    /** 01. Top Nav
 **************************************************************** **/
function _topNav() {
	var addActiveClass = false;

	jQuery("#topMain li.dropdown > a, #topMain li.dropdown-submenu > a").bind("click", function(e) {
		if(jQuery(this).attr('href') == '#') {
			e.preventDefault();
		}

		e.stopPropagation();

		if(jQuery(window).width() > 979) {
			return;
		}


		addActiveClass = jQuery(this).parent().hasClass("resp-active");
		jQuery("#topMain").find(".resp-active").removeClass("resp-active");

		if(!addActiveClass) {
			jQuery(this).parents("li").addClass("resp-active");
        }

		return;

	});

	// Drop Downs - do not hide on click
	// jQuery("#topHead .dropdown-menu, #topNav .mega-menu .dropdown-menu").bind("click", function(e) {
	// 	e.stopPropagation();
	// });

	jQuery(window).scroll(function() {

		if(jQuery(window).width() > 1006) {
			topMain(); // on scroll
		}

	});	
	
	if(jQuery(window).width() > 1006) {
		topMain(); // on load
	}



		// #topHead Fixes
		window._headHeight		= 81;
		window._headHeightSmall	= 30;

		function _topNavCalibrate() {

			if(jQuery("#topHead").length > 0) {
				window._headHeight 		= jQuery("header#topHead").outerHeight() + jQuery("header#topNav").outerHeight() - 10;
				window._headHeightSmall	= 66;

				jQuery('#wrapper').css({"padding-top":window._headHeight + "px"});
				jQuery('#topHead').removeClass('fixed').addClass('fixed');

				if(jQuery('#header_shadow').length > 0) {
					jQuery('#header_shadow').css({"top":window._headHeight + "px"});
				}

			} else {

				if(jQuery(window).width() < 1006) {
					//jQuery('#wrapper').css({"margin-top":"-30px"});
					jQuery('#header_shadow').css({"top":"40px"});
				} else {
					jQuery('#wrapper').css({"margin-top":"0px"});

					// From mobile back to desktop - do not leave the shadow behing
					if(jQuery(window).scrollTop() > 3) {
						jQuery('#header_shadow').css({"top":"60px"});
					} else {
						jQuery('#header_shadow').css({"top":"80px"});
					}
				}

			}

		}

		// recalibrate menu (mobile = slim mode) on resize
		jQuery(window).resize(function() {
			_topNavCalibrate();
		});	_topNavCalibrate();


	// scoll is on top!
	window.topNavSmall = false;


	function topMain() {
		var _scrollTop 		= jQuery(document).scrollTop();

		if(window.topNavSmall === false && _scrollTop > 0) {
		
			jQuery('header#topNav div.nav-main-collapse').addClass('topFix');
			jQuery('#topNav').stop().animate({ 'height':'60px'},400);
			jQuery('header#topNav div.nav-main-collapse').stop().animate({ 'margin-top':'6px'},400);
			jQuery('header#topNav button').stop().animate({ 'margin-top':'0'},100);
			jQuery('header#topNav a.logo').stop().animate({ 'margin-top':'-10px'},400);

			if(jQuery('#header_shadow').length > 0) {
				jQuery('#header_shadow').stop().animate({ 'top':window._headHeightSmall + 'px'},400);/* just a little visible */
			}

			window.topNavSmall = true;
		} 

		if(window.topNavSmall === true && _scrollTop < 3) {
			jQuery('header#topNav div.nav-main-collapse').removeClass('topFix');
			jQuery('#topNav').stop().animate({ 'height':'81px'},400);
			jQuery('header#topNav div.nav-main-collapse').stop().animate({ 'margin-top':'16px'},400);
			jQuery('header#topNav button').stop().animate({ 'margin-top':'8px'},100);
			jQuery('header#topNav a.logo').stop().animate({ 'line-height':'50px', 'margin-top':'0'},400);

			if(jQuery('#header_shadow').length > 0) {
				jQuery('#header_shadow').stop().animate({ 'top':window._headHeight + 'px'},400);
			}

			window.topNavSmall = false;
		}

	}
};

function userInfoChanged(scope, UserInfoService, $location){
	scope.$watch(function(){
		return UserInfoService.userInfo.isAuthenticated;
	}, function(){
		scope.isUserAuthenticated = UserInfoService.userInfo.isAuthenticated;
		scope.userName = UserInfoService.userInfo.userName;
		scope.misDatosUrl = function(){
			$location.path('/editar-atleta/' + UserInfoService.userInfo.fullUser.id);
		}
		scope.esOrganizador = UserInfoService.esOrganizador();
		scope.verFullEventosMenu = UserInfoService.esOrganizador();
		SetPermisos(UserInfoService.userInfo.permisos);
	});

	function SetPermisos(permisos){
		
		if(!permisos) return;

		permisos.forEach((element, index, array) => {
			switch(element.permisoId){
				case 1: //Administrar
					scope.permisoAdministrar = element.ver;
					break;
				case 2: //Usuarios
					scope.permisoUsuarios = element.ver;
					break;
				case 3: //Grupos
					scope.permisoGrupos = element.ver;
					break;
				case 4: //Organizadores
					scope.permisoOrganizadores = element.ver;
					break;
				case 5: //Usuarios Organizador
					scope.permisoUsuariosOrganizador = element.ver;
					break;
				case 10: //Eventos
					scope.permisoEventos = element.ver;
					break;
				case 20: //Inscripciones
					scope.permisoInscripciones = element.ver;
					break;
				case 30: //Reportes
					scope.permisoReportes = element.ver;
					break;
				case 40: //Cupones
					scope.permisoCupones = element.ver;
					break;
				case 50: //Categorias
					scope.permisoCategorias = element.ver;
					break;
				case 60: //Agregar Tiempos
					scope.permisoAgregarTiempos = element.ver;
					break;
				case 70: //Asignar Numeros
					scope.permisoAsignarNumeros = element.ver;
					break;
				case 80: //Parametros
					scope.permisoParametros = element.ver;
					break;
				case 90: //Paquetes
					scope.permisoPaquetes = element.ver;
					break;
				case 100: //Reportes Socios
					scope.permisoReportesSocios = element.ver;
					break;
				case 101: //Reportes Socios inscripciones
					scope.permisoReportesSociosInscripciones = element.ver;
					break;
			}				
		});

	};
};

})();